<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    :value-key="itemName"
                    placeholder="请选择用户"/>
</template>

<script>
/**
 * @Description: 用户自动查询组件
 * @Author: 菩萨蛮
 * @Date: 2021/4/9 2:48 下午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import AutoComplete from '../../../mixins/common/AutoComplete';


export default {
  name: 'UserComplete',
  mixins: [AutoComplete],
  data() {
    return {
      url: '/user/user/page',
      itemName: 'name'
    };
  },
  methods: {
    async supplierSearch(qs, cb) {
      if (qs && qs !== '') {
        const { data } = await
          this.qPost({
            url: `${this.url}`,
            data: {
              name: qs,
              pageNum: 1,
              pageSize: 5
            }
          });
        cb(data && data.list && data.list.length > 0 ? data.list : []);
      } else {
        cb([]);
      }
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
